export const contactSections = [
  { disabled: true, value: "", title: "Technologie / Produktbereich" },
  { disabled: false, value: "Knitting", title: "Knitting" },
  { disabled: false, value: "Weaving", title: "Weaving" },
  { disabled: false, value: "Felting", title: "Felting" },
  { disabled: false, value: "Tufting", title: "Tufting" },
  { disabled: false, value: "Carding", title: "Carding" },
  { disabled: false, value: "Sewing", title: "Sewing" },
];
